import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";
import { InfoUser } from '../models/InfoUser';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  public url :string;

  constructor(private http:HttpClient) {
    this.url = CONSTANTES.api_url + "/users";
   }

  changePassword(datos: object){
    const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post<InfoUser>(this.url+"/password",JSON.stringify(datos),{ headers: iheaders });
  }

  forgotPassword(datos: object){
    const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post<InfoUser>(this.url+"/forgot-password",JSON.stringify(datos),{ headers: iheaders });
  }
}


